import { element } from "prop-types";
import React, { useEffect, useState } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import * as actions from "./_redux/Actions";
import $ from "jquery";
import { imageUrl } from "../UIHelpers";
// import { FieldFeedbackLabel } from "../../../_metronic/_partials/controls/forms/FieldFeedbackLabel";
// const getFieldCSSClasses = (touched, errors) => {
//     const classes = ["form-control", "form-control-solid"];
//     if (touched && errors) {
//         classes.push("is-invalid-select");
//     }

//     if (touched && !errors) {
//         classes.push("is-valid-select");
//     }

//     return classes.join(" ");
// };

const MultiUpload = ({
    field, // { name, value, onChange, onBlur }
    form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
    label,
    withFeedbackLabel = true,
    customFeedbackLabel,
    children,
    filter,
    ...props
}) => {

    const dispatch = useDispatch();
    const [count, setCount] = useState(0);
    const [fileData, setFileData] = useState([]);
    const { currentState } = useSelector(
        (state) => ({ currentState: state.upload }),
        shallowEqual
    );
    const { upload, imageField } = currentState

    const uploadImage = event => {
        console.log("event.target.files",event.target.files);
        if (event.target.files && event.target.files[0]) {
            let img = event.target.files[0];
            dispatch(actions.uploadImage({ img: img, name: field.name }));
        }
    }
    const removeFile = ind => {
        fileData.splice(ind, 1);
        props.onfileValueSet(fileData, imageField);
        setFileData(fileData);
        setCount(count + 1);
        $("#file-input").val('');
        // let removedFileArry = []
        // fileData.map((element,indElement) => {
        //     if(indElement != ind)
        //     {
        //         removedFileArry.push(element);
        //     }
        // })
        // props.onfileValueSet(removedFileArry, imageField);
        // setFileData(removedFileArry);
        // setCount(count + 1);
    }

    useEffect(() => {
        if (imageField === field.name) {
            // Initialize fileData as an array if it's not already
            const newFileData = fileData || [];
            newFileData.push(upload.image);
            props.onfileValueSet(newFileData, imageField);
            setFileData(newFileData);
            setCount(count + 1);
            // console.log("upload", upload)
        }
    }, [upload, imageField]);
    
      
    useEffect(() => {
        setFileData(props.file);
    }, [props.file]);

    return (
        <>
            {label && <label>Upload {label}</label>}
            <div className="form-group row">
                <div>
                    <div className="image-input image-input-empty image-input-outline" id="kt_image_5"
                        style={{ backgroundImage: `url(https://icons-for-free.com/iconfiles/png/512/box+document+outline+share+top+upload+icon-1320195323221671611.png)` }}
                    >
                        <div className="image-input-wrapper"></div>
                        <label className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow" data-action="change" title="Change Image" >
                            <i className="fa fa-pen icon-sm text-muted"></i>
                            <input type="file" name="image-upload" id="file-input" onChange={uploadImage} accept=".png, .jpg, .jpeg" />
                        </label>
                        <span className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow" data-action="remove" title="Remove Image">
                            <i className="ki ki-bold-close icon-xs text-muted"></i>
                        </span>
                    </div>
                </div>
                {
                    fileData && fileData.length > 0 && (
                        fileData.map((file, ind) =>
                            <div key={`multi${ind}`} className="thumb-image-display">
                                {/* <img alt="example" style={{ width: '100%' }} src={`${process.env.REACT_APP_UPLOADED_FILE_URL}/${file && file.default}`} /> */}
                                <img
                                    alt="example"
                                    style={{ width: '100%' }}
                                    src={imageUrl((file && file?.default)? file?.default :null)}

                                    />
                                <span className="btn btn-bg-danger btn-circle btn-danger btn-hover-text-primary btn-icon btn-shadow btn-xs"
                                    onClick={() => removeFile(ind)}
                                    title="Remove Image">
                                    <i className="ki ki-bold-close icon-xs"></i></span>
                            </div>
                        )
                    )
                }
            </div>

        </>
    );
}
export default MultiUpload;